import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Environment } from '../models/environment';

@Injectable({providedIn: 'root'})
export class EnvironmentService {
    private customEnv!: Environment;
    
    constructor() { }
    
    setCustomEnvironment(env: Environment) {
        this.customEnv = env;
    }

    getEnv(): string {
        return this.customEnv ? 'CUSTOM' : environment.name;
    }

    isProductionBuild(): boolean {
        return environment.production;
    } 

    getBuild(): string {
        return environment.version;
    }

    getPublicApiUrl(): string {
        return this.customEnv?.jayrideApi?.url || environment.jayrideApi.url;
    }

    getBookingAppUrl(): string {
        return this.customEnv?.links?.bookingApp || environment.links.bookingApp;
    }
    
    getJpressUrl(): string {
        return this.customEnv?.links?.jayrideHome || environment.links.jayrideHome;
    }

    getAuth0ClientId(): string {
        return this.customEnv?.auth0?.clientId || environment.auth0.clientId;
    }

    getAuth0Domain(): string {
        return this.customEnv?.auth0?.domain || environment.auth0.domain;
    }

    getAuth0Audience(): string {
        return this.customEnv?.auth0?.audience || environment.auth0.audience;
    }

    getCookieDomain(): string {
        return this.customEnv?.cookieDomain || environment.cookieDomain;
    }
}